import {
    Card,
    PageHeader,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
} from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import { ManagerAuthorization } from '@common/enums';
import { PageTemplate } from '@frontend/components/templates/PageTemplate';
import { translateKey } from '@frontend/translate';
import { assertHasAuthorization, useAbortableFetch } from '@frontend/utils';

interface IPeriodAndCareGroup {
    careGroup: string;
    period: string;
}

export function ImportNoShows() {
    const [periodsAndCareGroups, setPeriodsAndCareGroups] = useState<IPeriodAndCareGroup[]>([]);

    const abortableFetch = useAbortableFetch();

    assertHasAuthorization(ManagerAuthorization.importNoShows);

    useEffect(() => {
        loadPeriodsAndCareGroups();
    }, []);

    return (
        <PageTemplate width="medium">
            <PageHeader title={translateKey('imports.import')} />

            <Card>
                <Card.Header title={translateKey('imports.importedNoShowsPeriods')} />
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableHeader>{translateKey('common.period')}</TableHeader>
                                <TableHeader>{translateKey('common.careGroup')}</TableHeader>
                                <TableHeader></TableHeader>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {periodsAndCareGroups.map((periodAndCareGroup: IPeriodAndCareGroup) => (
                                <TableRow key={periodAndCareGroup.period + periodAndCareGroup.careGroup}>
                                    <TableCell>{periodAndCareGroup.period}</TableCell>
                                    <TableCell>{periodAndCareGroup.careGroup}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Card>
        </PageTemplate>
    );

    async function loadPeriodsAndCareGroups() {
        const result = await abortableFetch.fetchJson(
            '/api/fundusScreening/noShows/getDistinctValues?columns=period,careGroup',
            'GET'
        );
        if (result.json.items) {
            setPeriodsAndCareGroups(result.json.items);
        }
    }
}
